import PropTypes from 'prop-types';
import OutreachTabGroup from '../components/outreach-tab-group';
import OutreachDraftCard from '../components/outreach-draft-card';
import { useState } from 'react';
import OutreachActionMenu from './outreach-action-menu';

const OutreachEmailComponent = ({ drafts = [] }) => {
  const [activeTab, setActiveTab] = useState('Drafts');
  const [selectedDrafts, setSelectedDrafts] = useState([]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: '16px' }}>
        <OutreachTabGroup activeTab={activeTab} onTabChange={setActiveTab} draftsCount={drafts.length} />
        <OutreachActionMenu selectedDrafts={selectedDrafts} setSelectedDrafts={setSelectedDrafts} />
      </div>
      <div className="outreach-drafts-container">
        {activeTab === 'Drafts' && (
          <div className="outreach-drafts-heading">
            <h2>
              {' '}
              <strong>{drafts.length} Drafts</strong>
            </h2>
            {drafts.length &&
              drafts.map((draft) => (
                <OutreachDraftCard
                  key={draft.id}
                  draft={draft}
                  selectedDrafts={selectedDrafts}
                  setSelectedDrafts={setSelectedDrafts}
                />
              ))}
          </div>
        )}
        {activeTab === 'Scheduled'}
        {activeTab === 'Sent'}
      </div>
    </>
  );
};

OutreachEmailComponent.propTypes = {
  drafts: PropTypes.array.isRequired,
};

export default OutreachEmailComponent;
